import * as React from 'react';
const IconShare = (props) => (
  <svg
    width={32}
    height={29}
    style={{ width: 32, height: 29 }}
    viewBox="0 0 32 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.6875 4.70609C5.79197 4.70609 6.68734 5.60166 6.6875 6.70609C6.6875 7.81066 5.79207 8.70609 4.6875 8.70609H4V24.7061H28V8.70609H27.3125C26.2079 8.70609 25.3125 7.81066 25.3125 6.70609C25.3127 5.60166 26.208 4.70609 27.3125 4.70609H30C31.1045 4.70609 31.9998 5.60166 32 6.70609V26.7061C32 27.8107 31.1046 28.7061 30 28.7061H2C0.89543 28.7061 0 27.8107 0 26.7061V6.70609C0.000159758 5.60166 0.895529 4.70609 2 4.70609H4.6875ZM14.7373 0.44828C15.5228 -0.192401 16.6818 -0.146198 17.4141 0.585976L23.4141 6.58598C24.1951 7.36699 24.195 8.63305 23.4141 9.4141C22.633 10.1951 21.367 10.1951 20.5859 9.4141L18 6.82816V18.4698C18 19.5743 17.1045 20.4697 16 20.4698C14.8955 20.4697 14 19.5743 14 18.4698V6.82816L11.4141 9.4141C10.633 10.1951 9.36698 10.1951 8.58594 9.4141C7.80496 8.63306 7.80494 7.36701 8.58594 6.58598L14.5859 0.585976L14.7373 0.44828Z"
      fill="#020000"
    />
  </svg>
);
export default IconShare;
